import { environment } from '../environments/environment';

export function getRuntimeConfig(): typeof environment.config {
  const params = new URLSearchParams(window.location.search);

  return {
    ...environment.config,
    appName: params.get('appName') ?? ''
  };
} 

export function getAppName(): string {
  return getRuntimeConfig().appName || '';
}
